import { Component , ViewChild } from '@angular/core';
import { MatAccordion } from '@angular/material/expansion';

import { ConfigurationService } from '../../_services/configuration.service';
import { AccountService } from '../../_services';
import { first } from 'rxjs/operators';

import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {MatChipInputEvent} from '@angular/material/chips';

import { FormControl } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';

import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {MatPaginator} from '@angular/material/paginator';


// Charts Temp
import { single , multi , ELEMENT_DATA} from './data';

// Depending on whether rollup is used, moment needs to be imported differently.
// Since Moment.js doesn't have a default export, we normally need to import using the `* as`
// syntax. However, rollup creates a synthetic default module and we thus need to import it using
// the `default as` syntax.
import * as moment from 'moment';

// For mat select
export interface FilterSelect {
    selected: boolean;
    filters ?: FilterArr[];
  }

export interface FilterArr {
    name: String;
    selected: boolean;
  }

@Component({ selector: 'charts-app',
             templateUrl: 'charts.component.html',
             styleUrls: ['charts.component.scss'],
             providers: [
                // `MomentDateAdapter` and `MAT_MOMENT_DATE_FORMATS` can be automatically provided by importing
                // `MatMomentDateModule` in your applications root module. We provide it at the component level
                // here, due to limitations of our example generation script.
                {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
                {provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS},
              ] })

export class ChartsComponent{
    @ViewChild(MatAccordion) accordion: MatAccordion;

    minDate1: Date;  
    maxDate1: Date;

    date1 = new FormControl(new Date(moment(new Date()).subtract(30, 'd').toDate())); //Date of fist date
    date2 = new FormControl(new Date()); //Date of fist date
    start_date: any;
    end_date: any;
    use_date_filter = false;

    // expanded sidenav
    isExpanded = true;

    // Progress query
    query_in_progress = false;

    checked = true;

    group: FilterSelect = {
        selected: false,
        filters: []
    };      
    device: FilterSelect = {
        selected: false,
        filters: []
    };    
    alert: FilterSelect = {
        selected: false,
        filters: []
    };      
    edge_loc: FilterSelect = {
        selected: false,
        filters: []
    };
    cam_name: FilterSelect = {
        selected: false,
        filters: []
    };
    cam_loc: FilterSelect = {
        selected: false,
        filters: []
    };

    selected_filters = {
    "group" : [],
    "device" : [],
    "alert" : [],
    "edge_loc" : [],
    "cam_name" : [],
    "cam_loc": []
    }

    // Variable to store Alerts Data
    stats_data = null;

    // Chart Data Starts
    // Stat Cards
    single: any[];
    view: any[] = [ , 150];

    colorScheme = {
        domain: ['#5AA454', '#E44D25', '#CFC0BB', '#7aa3e5', '#a8385d', '#aae3f5']
    };
    cardColor: string = '#232837';

    // Line chart
    multi: any[];
    // options
    legend: boolean = true;
    showLabels: boolean = true;
    animations: boolean = true;
    xAxis: boolean = true;
    yAxis: boolean = true;
    showYAxisLabel: boolean = true;
    showXAxisLabel: boolean = true;
    xAxisLabel: string = 'Date';
    yAxisLabel: string = 'Alert Count';
    timeline: boolean = true;

    // Chart Data Ends

    // Input for charts
    cards_data = null;
    chart_1_data = null;
    table_1_data = null;

    // Table Data Starts
    displayedColumns: string[] = ['group', 'location', 'serialno', 'camera','count'];
    dataSource = new MatTableDataSource(ELEMENT_DATA);

    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    // Table Data Ends

    constructor(
    private configurationservice:ConfigurationService,
    private accountService: AccountService,
     ) {
        Object.assign(this, { single });
        Object.assign(this, { multi });
     }

    // Fetch account data
    account = this.accountService.accountValue;

    ngOnInit() {
        this.start_date = moment(new Date());
        this.minDate1 = new Date(moment(new Date()).subtract(30, 'd').toDate());
        this.maxDate1 = new Date(moment(new Date()).add(0, 'd').toDate());

        console.log("account",this.account);

        // Fetch Device Group names
        this.fetch_va_filters();

        // Fetch Data with empty filter selection
        this.fetch_va_data(0,10);
    }

    ngAfterViewInit() {
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
    }

    // For Drawer collapse 
    showFiller = false;
    drawerSymbol(){
        this.showFiller = !this.showFiller;
    }

    // Fetch Device Group names
    fetch_va_filters(){
    this.configurationservice.fetch_va_filters(this.account.user_data)
    .pipe(first())
            .subscribe((res: any) => {
                console.log("filters",res);

                this.alert.filters = []
                for(let data of res[0].alert_type){
                    let tmp = { "name" : data , "selected" : true };
                    this.alert.filters.push(tmp);
                }

                this.group.filters = []
                for(let data of res[0].group){
                    let tmp = { "name" : data , "selected" : true };
                    this.group.filters.push(tmp);
                }

                this.cam_loc.filters = []
                for(let data of res[0].cam_loc){
                    let tmp = { "name" : data , "selected" : true };
                    this.cam_loc.filters.push(tmp);
                }

                this.cam_name.filters = []
                for(let data of res[0].cam_name){
                    let tmp = { "name" : data , "selected" : true };
                    this.cam_name.filters.push(tmp);
                }

                this.edge_loc.filters = []
                for(let data of res[0].edge_loc){
                    let tmp = { "name" : data , "selected" : true };
                    this.edge_loc.filters.push(tmp);
                }

                this.device.filters = []
                for(let data of res[0].serialno){
                    let tmp = { "name" : data , "selected" : true };
                    this.device.filters.push(tmp);
                }

            });
    }

    // Fetch Data with empty filter selection
    fetch_va_data(skip , limit){
    this.query_in_progress = true;
    // Create query based on selected filters
    let tmp_filters = {};

    for (var key of Object.keys(this.selected_filters)) {
        if(this.selected_filters[key].length > 0){
        tmp_filters[key] = this.selected_filters[key];
        }
    }

    if(this.use_date_filter){
        tmp_filters['gt'] = this.start_date;
        tmp_filters['lt'] = this.end_date;
    }

    console.log("tmp_filters",tmp_filters);

    this.configurationservice.fetch_dash_stats(this.account.user_data , tmp_filters , skip , limit)
        .pipe(first())
            .subscribe((res: any) => {
                this.stats_data = res;
                console.log("dash stats",this.stats_data);
                this.cards_data = this.stats_data.response.card_data;
                this.structure_chart_data();
                this.table_1_data = this.stats_data.response.table_1_data;
                this.query_in_progress = false;
            });

    }

    // Structure chart data for ngx charts
    structure_chart_data(){
        var final_chart_data =[];
        this.cards_data.forEach(el1 => {
            let temp_data = {};
            temp_data['name'] = el1['name'];
            temp_data['series'] = []
            this.stats_data.response.chart_1_data.forEach(el2 => {
                if(el2.length > 1){
                    var temp_count = 0;
                    for( var i=0 ; i < (el2.length-1) ; i++){
                        if(el2[i]['name']==el1['name']) temp_count = el2[i]['count'];
                    }
                    temp_data['series'].push({ "value" : temp_count , "name" : el2[el2.length-1]['end_time'] })
                }
                else{
                    temp_data['series'].push({ "value" : 0 , "name" : el2[0]['end_time'] })
                }
            });
            final_chart_data.push(temp_data);
        });
        console.log("Chart data",final_chart_data);
        this.chart_1_data = final_chart_data;
    }

    addEvent(type: string, event: MatDatepickerInputEvent<Date>,datenum: string) {

        const event_date = new Date(event.value); 
        const moment_date = moment(event_date);

        //If this is the date from Number Plate section
        if( datenum == "date1_start"){  //If this is the date from Number Plate section
        this.start_date = moment_date;
        // temp var to store event date
        let temp_date = moment(event_date);
        this.minDate1 = new Date(moment(event_date).add(1, 'd').toDate());
        temp_date = moment(event_date);
        this.maxDate1 = new Date(moment(event_date).add(30, 'd').toDate());

        }else if( datenum == "date1_end"){
        this.end_date = moment_date;
        this.use_date_filter = true;
        console.log("Fetch Data here",this.start_date,moment_date);
        // Fetch Data
        this.fetch_va_data(0,10);
        }
    }


    // Code for all Selction checkbox filters Starts

    // Groups
    allSelected_Group: boolean = false;
    updateAllSelected_Group() {
        this.allSelected_Group = this.group.filters != null && this.group.filters.every(t => t.selected);
    }
    someSelected_Group(): boolean {
        if (this.group.filters == null) {
        return false;
        }
        return this.group.filters.filter(t => t.selected).length > 0 && !this.allSelected_Group;
    }
    setAll_Group(selected: boolean) {
        this.allSelected_Group = selected;
        if (this.group.filters == null) {
        return;
        }
        this.group.filters.forEach(t => t.selected = selected);
    }

    // Device
    allSelected_Device: boolean = false;
    updateAllSelected_Device() {
        this.allSelected_Device = this.device.filters != null && this.device.filters.every(t => t.selected);
    }
    someSelected_Device(): boolean {
        if (this.device.filters == null) {
        return false;
        }
        return this.device.filters.filter(t => t.selected).length > 0 && !this.allSelected_Device;
    }
    setAll_Device(selected: boolean) {
        this.allSelected_Device = selected;
        if (this.device.filters == null) {
        return;
        }
        this.device.filters.forEach(t => t.selected = selected);
    }

    // Device
    allSelected_Alert: boolean = false;
    updateAllSelected_Alert() {
        this.allSelected_Alert = this.alert.filters != null && this.alert.filters.every(t => t.selected);
    }
    someSelected_Alert(): boolean {
        if (this.alert.filters == null) {
        return false;
        }
        return this.alert.filters.filter(t => t.selected).length > 0 && !this.allSelected_Alert;
    }
    setAll_Alert(selected: boolean) {
        this.allSelected_Alert = selected;
        if (this.alert.filters == null) {
        return;
        }
        this.alert.filters.forEach(t => t.selected = selected);
    }

    // Edge Location
    allSelected_Edge_loc: boolean = false;
    updateAllSelected_Edge_loc() {
        this.allSelected_Edge_loc = this.edge_loc.filters != null && this.edge_loc.filters.every(t => t.selected);
    }
    someSelected_Edge_loc(): boolean {
        if (this.edge_loc.filters == null) {
        return false;
        }
        return this.edge_loc.filters.filter(t => t.selected).length > 0 && !this.allSelected_Edge_loc;
    }
    setAll_Edge_loc(selected: boolean) {
        this.allSelected_Edge_loc = selected;
        if (this.edge_loc.filters == null) {
        return;
        }
        this.edge_loc.filters.forEach(t => t.selected = selected);
    }

    // Cam Name
    allSelected_Cam_name: boolean = false;
    updateAllSelected_Cam_name() {
        this.allSelected_Cam_name = this.cam_name.filters != null && this.cam_name.filters.every(t => t.selected);
    }
    someSelected_Cam_name(): boolean {
        if (this.cam_name.filters == null) {
        return false;
        }
        return this.cam_name.filters.filter(t => t.selected).length > 0 && !this.allSelected_Cam_name;
    }
    setAll_Cam_name(selected: boolean) {
        this.allSelected_Cam_name = selected;
        if (this.cam_name.filters == null) {
        return;
        }
        this.cam_name.filters.forEach(t => t.selected = selected);
    }

    // Cam Location
    allSelected_Cam_loc: boolean = false;
    updateAllSelected_Cam_loc() {
        this.allSelected_Cam_loc = this.cam_loc.filters != null && this.cam_loc.filters.every(t => t.selected);
    }
    someSelected_Cam_loc(): boolean {
        if (this.cam_loc.filters == null) {
        return false;
        }
        return this.cam_loc.filters.filter(t => t.selected).length > 0 && !this.allSelected_Cam_loc;
    }
    setAll_Cam_loc(selected: boolean) {
        this.allSelected_Cam_loc = selected;
        if (this.cam_loc.filters == null) {
        return;
        }
        this.cam_loc.filters.forEach(t => t.selected = selected);
    }

    // Set Selected to all filters
    setAll_Filters(selected: boolean) {
    this.group.filters.forEach(t => t.selected = selected);
    this.device.filters.forEach(t => t.selected = selected);
    this.alert.filters.forEach(t => t.selected = selected);
    this.edge_loc.filters.forEach(t => t.selected = selected);
    this.cam_name.filters.forEach(t => t.selected = selected);
    this.cam_loc.filters.forEach(t => t.selected = selected);
    this.use_date_filter = false;
    }

    // Code for all Selction checkbox filters Ends 

    // Filter Set callback
    set_filter(filter_type){
    console.log("filter_type",filter_type);
    switch (filter_type) {
        case "group":
            this.selected_filters.group =[];
            this.group.filters.forEach(element => {
            if(element.selected){
                this.selected_filters.group.push(element.name);
            }
            }); 
            console.log("selected filters",this.selected_filters);
            break;
        case "device":
            this.selected_filters.device =[];
            this.device.filters.forEach(element => {
            if(element.selected){
                this.selected_filters.device.push(element.name);
            }
            }); 
            console.log("selected filters",this.selected_filters);
            break;
        case "alert":
            this.selected_filters.alert =[];
            this.alert.filters.forEach(element => {
            if(element.selected){
                this.selected_filters.alert.push(element.name);
            }
            }); 
            console.log("selected filters",this.selected_filters);
            break;
        case "edge_loc":
            this.selected_filters.edge_loc =[];
            this.edge_loc.filters.forEach(element => {
            if(element.selected){
                this.selected_filters.edge_loc.push(element.name);
            }
            }); 
            console.log("selected filters",this.selected_filters);
            break;
        case "cam_name":
            this.selected_filters.cam_name =[];
            this.cam_name.filters.forEach(element => {
            if(element.selected){
                this.selected_filters.cam_name.push(element.name);
            }
            }); 
            console.log("selected filters",this.selected_filters);
            break;
        case "cam_loc":
            this.selected_filters.cam_loc =[];
            this.cam_loc.filters.forEach(element => {
            if(element.selected){
                this.selected_filters.cam_loc.push(element.name);
            }
            }); 
            console.log("selected filters",this.selected_filters);
            break;
        case "reset":
            for (var key of Object.keys(this.selected_filters)) {
            this.selected_filters[key] = []
            }
            console.log("Resetting Filters",this.selected_filters);
            // collapse accordian
            this.accordion.closeAll();
            // Set all Checkboxes
            this.setAll_Filters(true);
            break;
        default:
            console.log("Filter selection default")
            break;
    }

    // Fetch VA Data with selected Filters
    this.fetch_va_data(0,10);
    }

}